if (!customElements.get('brand-index')) {
    customElements.define(
        'brand-index',
        class BrandIndex extends HTMLElement {
            static CACHE_KEY = 'brand_availability';
            static CACHE_TTL = 86400000;

            constructor() {
                super();
                this.cache = this.loadCache();
                this.querySelectorAll('[data-show-letter]').forEach((btn) => {
                    btn.addEventListener('click', () => this.setActive(btn));
                });
                this.processGroups();
            }

            setActive(btn) {
                this.querySelectorAll('[data-show-letter]').forEach((b) => b.classList.remove('active'));
                btn.classList.add('active');
            }

            loadCache() {
                try {
                    const raw = localStorage.getItem(BrandIndex.CACHE_KEY);
                    if (!raw) return {};
                    const { timestamp, data } = JSON.parse(raw);
                    if (Date.now() - timestamp > BrandIndex.CACHE_TTL) {
                        localStorage.removeItem(BrandIndex.CACHE_KEY);
                        return {};
                    }
                    return data;
                } catch {
                    return {};
                }
            }

            saveCache() {
                try {
                    localStorage.setItem(
                        BrandIndex.CACHE_KEY,
                        JSON.stringify({ timestamp: Date.now(), data: this.cache })
                    );
                } catch {}
            }

            async processGroups() {
                for (const group of this.querySelectorAll('.brand-item-wrapper')) {
                    if (group.classList.contains('brand-index__deferred')) {
                        group.classList.add('brand-index__deferred--loading');
                    }
                    await this.checkGroupAvailability(group);
                    group.querySelector('.brand-index__loader')?.remove();
                    group.classList.remove('brand-index__deferred', 'brand-index__deferred--loading');
                    this.updateGroupVisibility(group);
                }
                this.saveCache();
            }

            async checkGroupAvailability(group) {
                const items = [...group.querySelectorAll('[data-collection-handle]')];
                const BATCH_SIZE = 6;

                for (let i = 0; i < items.length; i += BATCH_SIZE) {
                    await Promise.all(
                        items.slice(i, i + BATCH_SIZE).map(async (item) => {
                            const handle = item.dataset.collectionHandle;
                            let available;

                            if (handle in this.cache) {
                                available = this.cache[handle];
                            } else {
                                available = await this.hasActiveProducts(handle);
                                this.cache[handle] = available;
                            }

                            if (!available) item.setAttribute('data-unavailable', '');
                        })
                    );
                }
            }

            async hasActiveProducts(handle) {
                try {
                    const res = await fetch(`/collections/${encodeURIComponent(handle)}.json`);
                    if (!res.ok) return false;
                    const { collection } = await res.json();
                    return collection?.products_count > 0;
                } catch {
                    return false;
                }
            }

            updateGroupVisibility(group) {
                const letter = group.dataset.itemLetter;
                const filterItem = this.querySelector(`[data-filter-letter="${letter}"]`);
                const hasVisible = group.querySelector('.brand-index__item:not([data-unavailable])');

                if (!hasVisible) group.style.display = 'none';
                filterItem?.classList.toggle('disable', !hasVisible);
            }
        }
    );
}